import { Search } from "lucide-react";
import { Input, cn } from "twyne-new.ui";

export default function InputSearchList({ placeholder, onChange, value, className, children }) {
  return <div className={cn('px-2 rounded-sm bg-gray-200 dark:bg-gray-1300', className)}>
    <div className='relative w-full'>
      <Search size='18' className='absolute left-0 top-1/2 -translate-y-1/2 z-10 twy-text-base' />
      <Input
        name="filter"
        placeholder={placeholder}
        className="border-0 w-full z-0 pl-6 bg-transparent!"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
    {children}
  </div>
}
